/**
 * `exceptions.business.theSameAddress` is thrown with a `key` but **no `slug`**
 * (`apps/api/src/business-location/business-location.service.ts`), so the only
 * thing that reaches the client is the translated sentence. Matching it is the
 * one way the location form can tell a duplicate address from any other 400 —
 * and since the legacy app started sending `x-lang`, that sentence arrives in
 * the merchant's language, so matching English alone silently stopped working
 * for a Brazilian merchant.
 *
 * Every catalogue that translates the key must be listed here. The real fix is
 * a `slug` on the backend exception, as its `theSameLocationName` sibling
 * already has; drop this list the day it lands.
 */
const DUPLICATE_ADDRESS_MESSAGES = [
  'there is another business using this address',
  'há outro estabelecimento usando este endereço'
];

export const isDuplicateAddressError = (message?: string | null): boolean => {
  if (!message) return false;

  return (
    DUPLICATE_ADDRESS_MESSAGES.indexOf(
      String(message)
        .trim()
        .toLowerCase()
    ) !== -1
  );
};
